import { Timestamp } from "../types/Timestamp";
import type { IOrderTemplate } from "../types/order/IOrderTemplate";

type TemplateSummary = Pick<IOrderTemplate, "createdAt" | "name" | "id">;

/** REST dates and Firestore timestamps sort alike; undated legacy templates go last. */
export const compareTemplatesNewestFirst = (
  a: TemplateSummary,
  b: TemplateSummary,
): number => {
  const createdAt = (template: TemplateSummary) => {
    const date = Timestamp.toMoment(template.createdAt);
    return date.isValid() ? date.valueOf() : -Infinity;
  };
  const aTime = createdAt(a);
  const bTime = createdAt(b);
  return (
    (aTime === bTime ? 0 : aTime > bTime ? -1 : 1) ||
    a.name.localeCompare(b.name) ||
    a.id.localeCompare(b.id)
  );
};
